// Thin wrapper around the bundle-row "stay open after refresh" helpers.
//
// The functions themselves are defined by the zd-wishlist plugin
// (wordpress/web/app/plugins/zd-wishlist/assets/js/wishlist.js) and exposed as
// window.remember_open_bundle_box / window.restore_open_bundle_box. The plugin
// owns this state because it manages bundle rows in both cart and wishlist.
//
// Importing this module from theme code keeps callers free of the typeof check
// boilerplate and gives us a single place to swap the contract if the plugin
// is ever folded into the theme bundle.

export function remember(item_signature) {
    if (typeof window.remember_open_bundle_box === 'function') {
        window.remember_open_bundle_box(item_signature);
    }
}

export function restore(list_type) {
    if (typeof window.restore_open_bundle_box === 'function') {
        window.restore_open_bundle_box(list_type);
    }
}
